import { ACCESS_IS_MOBILE } from '../actions/actionTypes'

export const mobileActive = () => ({
    type: ACCESS_IS_MOBILE,
    mobileActive: window.innerWidth <= 768 ? true : false
});


// WEBPACK FOOTER //
// ./src/actions/mobileActions.js